const routes = {
  base: "/",
  home: "/home",
  login: "/login",
  unilogin: "/unilogin",
  oldlogin: "/old_login",

  internalUserLogin: "/internal_login",
  passwordForgot: "/forgot",
  passwordRenew: "/passwordRestore/:requestId",
  register: "/register",
  dashboard: "/dashboard",
  user: "/user",
  zapFeed: "/zap-feed",
  invoicing: "/invoicing",
  campaigns: "/campaigns",
  search: "/search",
  trackers: "/search/trackers",
  blitzpay: "/blitzpay",
  blitzpayInternalTransfer: "/blitzpay/internal-transfer",
  blitzpayPayoutRouting: "/blitzpay/payout-routing",
  paypage: "/pay",

  addCreators: "/add-creators/:campaignId",
  resources: "/resources",
  about: "/about",
  creatorSignup: "/creatorsignup",
  company: "/company",
  campaignPublic: "/campaigns/:campaignId",
  campaignReport: "/campaigns/report/:campaignId",
  campaignCatalog: "/catalog/:campaignId",

  campaignTimeline: "/campaigns/:campaignId/timelines",
  creatorCampaignTimeline: "/campaigns/:campaignId/creator/:creatorId/timelines", // Add this line for the new route
  creatorMediaKit: "/creators/:creatorId",
  roster: "/roster/:manager", // New route for the AgencyCreatorRoster component
  tempRoster: "/temp_roster/:manager", // New route for the AgencyCreatorRoster component
  creatorConnectReauth: "/creatorconnect/reauth/:creator",
  creatorConnect: "/creatorconnect/:creator",
  creatorLogin: "/creatorconnect/login",
  internalLogin: "/creatorconnect/internal_login",
  creatorConnectCampaigns: "/creatorconnect/campaigns",
  creatorConnectStart: "/creatorconnect/start",
  creatorConnectOnboard: "/creatorconnect/onboard",
  creatorConnectOnboardApp: "/creatorconnect/onboardoauth",
  commisions: "/commissions",
  creatorPayoutInvoices: "/creatorinvoice",
  creatorCRMPublic: "/creatorCRM",
  requestAccess: "/requestaccess",
  similarCreators: "/creators/:creatorId/similar",
  demoRegister: "/demoregister",
  about: "/about",
  deliverablePage: "/partnerships/:partnershipId/creator/:creatorId/deliverables", // Add this line for the new route
  tempCreator: "/tempCreator/:creatorId",
  help: "/help",
  files: "/files",
  editCampaign: "/editcampaign/:campaignId",
  partnershipsPage: "/partnerships/:partnershipId",
  solutions: "/solutions",
  solutionsAgencies: "/agency_solutions",
  forcreators: "/forcreators",
  
  creatorConnectOauth: "/creatorconnect/oauth",
  creatorConnectDashboard: "/creatorconnect/dashboard",
  creatorConnectGoogle: "/creatorconnect/redirect",
  creatorConnectCampaigns: "/creatorconnect/campaigns",
  creatorConnectPayoutsInvoicing: "/creatorconnect/payouts-invoicing",
  creatorConnectInternalTransfer: "/creatorconnect/internal-transfer",
  creatorConnectPitch: "/creatorconnect/pitch",
  creatorConnectPartnerships: "/creatorconnect/partnerships",
  creatorConnectEdit: "/creatorconnect/edit",
  creatorConnectDealsEmails: "/creatorconnect/deals-emails",
  creatorConnectMore: "/creatorconnect/more",
  creatorConnectCommissions: "/creatorconnect/commissions",
  creatorConnectApps: "/creatorconnect/apps",
  creatorConnectAppsSpec: "/creatorconnect/apps/:appId",

  creatorCampaigns: "/creatorconnect/campaigns/:campaignId",
  whypartner: "/whypartner",
  trackers: "/trackers",
  trackerPublic: "/tracker/:trackerId",

  creaotrParntershipsSpecific: "/creatorconnect/partnerships/:partnershipId",
  pitchFromZap: "/creatorconnect/pitch/:type/:id",
  parntersListL: "/partners",
  campaignconvospec: "/campaigns/convo/:campaignId/:creatorName",
  privacyPolicy: "/privacypolicy",
  
  agency: "/agency/",
  agencyDealFlow: "/agency/deal-flow", // NEW: Deal flow management page
  agencyRosterSettings: "/agency/roster-settings", // NEW: Roster customization page
  agencyCreators: "/agency/creators",
  agencyCreatorCollaborations: "/agency/creators/:creatorId/collaborations",
  agencyCreatorPartnership: "/agency/creators/:creatorId/collaborations/partnerships/:partnershipId",
  agencyCreatorCampaign: "/agency/creators/:creatorId/collaborations/campaigns/:campaignId",
  agencyCreatorSpecActivity: "/agency/creators/:creatorId/activity",

  agencyCreator: "/agency/creators/:creatorId",
  agencyCreatorPayouts: "/agency/creators/:creatorId/payouts",
  agencyCreatorPayout: "/agency/creators/:creatorId/payouts/:payoutId",
  agencyCreatorBio: "/agency/creators/:creatorId/bio",
  agencySales: "/agency/sales",
  agencyInvoice: "/agency/invoicing",
  agencyAllCollabs: "/agency/all-collaborations",
  agencyAllMoney: "/agency/all-money",



  campaignOptOut: "/campaigns/optout/:campaignId",
  partnerships: "/partnerships",
  castingCalls: "/casting",
  integrations: "/integrations",
  creatorCastingCalls: "/creatorconnect/casting",
  castingCallPublic: "/casting-calls/public/:slug",  // NEW: Public casting call page
  collaborations: "/collabs",
  creatorCollabs: "/creatorconnect/collabs",
  articles: "/articles",
  articlesSpec: "/articles/:slug",

  dealsIO: "/deals_factor",
  dealsIOSpec: "/deals/:dealId",
  manageDealsIO: "/deals/public/:dealId",
  payoutSpec: "/payouts",
  onboard: "/onboard",
  aiTest: "/testing",
  creatorDeals: "/creatorconnect/deals",
  creatorDealIOSpec: "/creatorconnect/deals/:dealId",

  intDocsHome: "/internaldocs",
  intDocsFrontend: "/internaldocs/frontend",
  intDocsBackend: "/internaldocs/backend",

  docsHome: "/docs",
  docsService: "/docs/services",
  docsKeys: "/docs/apikeys",
  docsOauth: "/docs/oauth",
  docsEndpoints: "/docs/endpoints",
  docsEndCreators: "/docs/endpoints/creators",
  releasteNotes: "/releases",
  campaignOffer: "/offer/:creator/:campaignId",
  contractSpec: "/contract/:id", // This handles both public (/contract/123?token=abc) and authenticated (/contract/123) access
  contractDirect: "/contract/:signatureId", // Alias for clarity - same route
  contractAccess: "/contract/:signatureId", // Another alias for direct access
  externalContractSpec: "/external-contract/:id", // This handles both public (/contract/123?token=abc) and authenticated (/contract/123) access

  userProfile: "/user/:userId",
  userProfilePublic: "/publicuser/:userId",
  conversationshub: "/convos",
  creatorInvoicing: "/creatorinvoicing",
  clientInvoicing: "/split",
  creatorBooking: "/search/creator_booking",
  agencyTerms: "/terms",
  vendorSignup: "/vendor_signup",
  creatorConvos: "/creatorconnect/convos",
  accessfile: "/files/:fileId",
  bioPublic: "/b/:slug", // Public bio page URL, e.g. "/@mycreatorpage"
  bioAtSlug: "/:slug",
  creatorbio: "/bio", // Public bio page URL, e.g. "/@mycreatorpage"
  joinConvo: "/join/:conversationId",
  creatorPartnerPresentation: "/partner/:creator/:referrer",
  newCreatorPartnerPresentation: "/new_partner/:referrer",
  partnerSuite: "/creatorconnect/partner",
  partnerSuiteIncoming: '/creator/partner-suite/incoming',
  partnerSuiteOutgoing: '/creator/partner-suite/outgoing',
  amDash: "/account_management",
  commerce: "/commerce",
  commerceTransactions: "/commerce/transactions",
  commerceCheckout: "/checkout/:slug",
  // Third-party integration hosted checkout (Stripe embedded) — distinct from
  // commerceCheckout above, which is the merchant-defined-product-link system.
  commerceEmbeddedCheckout: "/commerce/pay/:sessionId/:token",
  commerceEmbeddedCheckoutComplete: "/commerce/pay/:sessionId/:token/complete",
  newUserPresentation: "/new_user/:referrer",
  contactDash: "/contacts",
  claimPayout: "/payout/:token",
  claimFunds: "/claim-funds",
  investors: "/investors",
  create: "/create",
  collaborate: "/collaborate",
  creatorTerms: "/terms_creators",
  deleteAccount: "/delete_account",
  organizers: "/organizers",
  organizerDetail: "/organizers/:organizerId",
  publicOrganizer: "/organizer/:organizerId",  // Public access route with token in query params
  organizerChecklist: "/organizers/:organizerId/checklist", // NEW

  threadPage: "/thread/:postId",
  trophyRoom: '/trophy-room',
  globalUserInvite: '/invite/:globalUserId',
  claimSignup: "/claim-signup",
  globalProfile: "/profile/:slug",  // This will match /@username or /@user123
  accountLinker: '/global-linking',
  clientProfile: "/client/:clientId",  // This will match /@username or /@user123
  myReferrals: "my-referrals",
  amTracking: "/am-tracking",
  buttPay: "/buttpay",
  noaView: '/noa/view/:token',
  t2: "/t2",
  manageCastingCall: '/castingcall/:id/manage',
  bubblePublic: '/bubbles/:bubbleId',

  // PayPal OAuth callback
  paypalCallback: "/paypal/callback",

  // Stripe OAuth callback
  stripeCallback: "/stripe/callback",

  bubbleChat: "/bubble-chat/:conversationId", // NEW: Dedicated bubble chat route
  bubbleChatDirect: "/bubbles/:bubbleId/chat", // NEW: Alternative direct access

  notifications: '/notifications', // NEW: Notifications management page
  split: "/split1",
  payRequest: "/pay-request/:token",
  payRequestSuccess: "/pay-request/:token/success",

};

export default routes;